import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { select } from '@ngxs/store';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { JobPositionState } from 'src/app/competence/state/job-position.state';
import { PlannedActivityUserForm } from 'src/app/crew-management-user/forms/planned-activity.form';

@Component({
  selector: 'app-planned-activity-user-template',
  templateUrl: './planned-activity-user-template.component.html',
  styleUrls: ['./planned-activity-user-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PlannedActivityUserTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;
  form: PlannedActivityUserForm;

  getJobPositionsForDepartment = select(JobPositionState.getJobPositionsForDepartment);
}
